__webpack_require__.p = "https://almacademy-prod.azurewebsites.net/";